import { render, staticRenderFns } from "./AddSound.vue?vue&type=template&id=2cfacc66&"
import script from "./AddSound.vue?vue&type=script&lang=js&"
export * from "./AddSound.vue?vue&type=script&lang=js&"
import style0 from "./AddSound.vue?vue&type=style&index=0&id=2cfacc66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports